import { render, staticRenderFns } from "./ForgotPasswordPage.vue?vue&type=template&id=869fec22&scoped=true&"
import script from "./ForgotPasswordPage.vue?vue&type=script&lang=js&"
export * from "./ForgotPasswordPage.vue?vue&type=script&lang=js&"
import style0 from "./ForgotPasswordPage.vue?vue&type=style&index=0&id=869fec22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "869fec22",
  null
  
)

export default component.exports